import { httpClient } from '@/core/services/http'
import { createForgotPasswordUseCase } from '../use-cases/forgot-password.usecase'
import { createResetPasswordUseCase } from '../use-cases/reset-password.usecase'
import { createVerifyAccountUseCase } from '../use-cases/verify-code.usecase'

export const forgotPassword = createForgotPasswordUseCase({
  httpClient,
})

export const resetPassword = createResetPasswordUseCase({
  httpClient,
})

export const verifyAccount = createVerifyAccountUseCase({
  httpClient,
})
